import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

const composerSlice = createSlice({
  name: "composer",
  initialState: {
	items: [],
    status: "idle",
    error: null,
  },
  reducers: {
    clearItems: (state) => {
      state.items = [];
    },
    deleteItem: (state, action) => {
      const key = action.payload;
      state.items = state.items.filter((image) => image.key !== key);
    },
    addItem: (state, action) => {
      let character = action.payload;
      // disambiguate system loras ids and characters ids
      character.key = character.id + character.name;
      state.items.push(character);
    },
    updateItem: (state, action) => {
      const { key, strength, description } = action.payload;
      state.items = state.items.map((item) => {
        if(item.key === key){
          return {
            ...item,
            strength: strength === undefined ? item.strength : strength,
            description: description === undefined ? item.description : description,
          }
        }
        return item;
      })
    },
  },
});

export const { addItem, updateItem, deleteItem, clearItems } = composerSlice.actions;
export default composerSlice.reducer;
